import xs from "xstream"
import delay from "xstream/extra/delay"
import isolate from "@cycle/isolate"
import {div} from "@cycle/dom"
import * as R from "ramda"

import {STATE_KEY, INIT_STATE} from '../../constant'
import {createApiReq, createApiResp, apiOK} from '../common'

const eventReq = createApiReq(STATE_KEY.PdfEvents, 'GET')
const eventResp = createApiResp(STATE_KEY.PdfEvents)

const Loading = sources => {
	const eventResp$ = eventResp(sources.HTTP)

  const eventParser = R.compose(R.map(R.compose(JSON.parse, R.prop('name'))),R.sortBy(R.prop("value")))

  const initState$ = xs.of(_ => INIT_STATE)
	const state$ = eventResp$
		.filter(apiOK)
		.map(R.prop("data"))
		.map(({ pdfEvents, topText }: any) => {
			return R.mergeRight({
				pdfEvents: eventParser(pdfEvents),
				topText,
			})
		})
    // .map(eventParser)
		// .map((pdfEvents) => state => {
		// 	return R.mergeRight(state, { pdfEvents })
		// })

	const route$ = state$
		.compose(delay(1))
		.mapTo('/login')

	return {
		HTTP: xs.of(eventReq()),
		DOM: xs.of(div('Loading....')),
		state: xs.merge(initState$, state$),
		router: route$,
		loading: xs.of(true)
	}
}
export default isolate(Loading)
